import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../../../services/admin.service';
import { FormGroup, FormControl } from '@angular/forms';
import { SearchParams } from '../../../../modals/users-search-params/users-search-params.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../../../../models/user.model';
import { UserService } from '../../../../services/user.service';
import { StepsControllerService } from '../../../../services/steps-controller.service';

@Component({
  selector: 'users-standarts-report',
  templateUrl: './users-standarts-report.component.html',
  styleUrls: ['./users-standarts-report.component.scss']
})
export class UsersStandartsReportComponent implements OnInit {
  user: User;
  page = 1;
  isLoaded = false;
  isLoadedList = false;
  totalPages;
  viewPagination = false;
  departments;
  positions;
  initialParams = {};
  searchParams = {
    limit: 10,
    offset: 1,
    status: [],
    language: [],
    searchFilter: "",
    dateRange: {
      startDate: "",
      endDate: "",
    },
    sort: {
      sortField: "lastName",
      order: "ASC"
    },
    roles: [],
    departments: [],
    positions: [],
  };
  loadGroups = false;
  items;
  userInfo = {};
  userGroups = {};
  loadUser = false;
  showDepartments = false;
  isAdmin = false;
  isHead = false;
  isUser = false;
  isHeadOfGroup = false;
  isDeputy = false;
  paramsForServer;
  errorMessage = false;
  paramsForDisplay = [];
  removableItems = [];
  noDataMessage = "No data";
  showGroups = true;
  showStatus = true;
  showPhone = true;
  showEmail = true;
  listStandarts;

  constructor(
    private router: Router,
    private adminService: AdminService,
    private modalService: NgbModal,
    private userService: UserService,
    private route: ActivatedRoute,
    public stepsControllerService: StepsControllerService
  ) {

  }

  ngOnInit() {
    this.user = this.userService.getLocal();
    if (this.user.role === 'ROLE_ADMIN') {
      this.isAdmin = true;
      this.isHead = true;
      this.isUser = true;
    } else if (this.user.role === 'ROLE_HEAD') {
      this.isAdmin = false;
      this.isHead = true;
      this.isUser = true;
    } else if (this.user.role === 'ROLE_USER') {
      this.isAdmin = false;
      this.isHead = false;
      this.isUser = true;
    }
    this.getGroups(this.route.snapshot.params['id']);
    // this.getAllUsers(this.initialParams);
    // this.getPositions();
  }

  getGroups(id) {
    this.errorMessage = false;
    this.userService.getReportStandartsUsers(id).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.listStandarts = JSON.parse(response.body);
          this.isLoadedList = true;
        }
      }, (error) => {
        this.errorMessage = true;
      }
    );
  }

  editThisStandard(standardID) {
		this.setTempStandardForEditing(standardID);
	}

	setTempStandardForEditing(id) {
		this.adminService.getTempStandard(id).subscribe(
		  (res: any) => {
			if (res.status === 200) {
			  const tmpStnd = res.body;
			  tmpStnd.status = "ON_EDITING";
			  this.stepsControllerService.activeStep = 8;
			  this.stepsControllerService.setTempParrentID(id);
			  this.stepsControllerService.setCurrentStandard(tmpStnd);
			}
	  })
	}

  getPositions() {
    this.errorMessage = false;
    this.adminService.getPositions().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.errorMessage = false;
          this.positions = response.body;
        }
      }, (error) => {
        this.errorMessage = true;
      }
    );
  }


  columnCustom(column) {
    switch (column) {
      case 'e-mail':
        this.showEmail = !this.showEmail;
        break;
      case 'phone':
        this.showPhone = !this.showPhone;
        break;
      case 'group':
        this.showGroups = !this.showGroups;
        break;
      case 'status':
        this.showStatus = !this.showStatus;
        break;

    }
  }

  getAllUsers(params) {
    this.isLoadedList = false;
    this.errorMessage = false;
    this.adminService.getUsersList(params).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.items = response.body.list;
          this.isLoadedList = true;
          if (response.body.total > 1) {
            this.viewPagination = true;
          } else {
            this.viewPagination = false;
          }
          this.totalPages = 10 * response.body.total;
        }
        this.isLoadedList = true;
        this.errorMessage = false;
      },
      (error) => {
        this.isLoadedList = true;
        this.errorMessage = true;
      }

    );

  }

  getUser(id) {
    this.isLoaded = false;
    this.errorMessage = false;
    this.adminService.getUserInfo(id).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.userInfo = response.body.user;
          this.userGroups = response.body.groupsWithPositions;
          this.loadUser = true;
          this.isLoaded = true;
          this.errorMessage = false;
          if (this.isEmptyObject(this.userGroups)) {
            this.showDepartments = false;
          } else {
            this.showDepartments = true;
          }
        }
      }, (error) => {
        this.errorMessage = true;
      }
    );
  }

  loadPage(page) {
    this.searchParams.offset = page;
    this.sendParams(this.searchParams);

  }

  setSortParams(field) {
    if (this.searchParams.sort.sortField === field && this.searchParams.sort.order === "ASC") {
      this.searchParams.sort.order = "DESC";
    } else if (this.searchParams.sort.sortField === field) {
      this.searchParams.sort.order = "ASC";
    }
    else {
      this.searchParams.sort.sortField = field;
      this.searchParams.sort.order = "ASC";
    }
    this.sendParams(this.searchParams);
  }

  onSearchChange(e) {
    this.searchParams.searchFilter = e;
    this.sendParams(this.searchParams);
  }

  sendParams(params) {
    this.paramsForServer = { ...params };
    for (const key in this.paramsForServer) {
      if (this.paramsForServer[key].length === 0 || this.paramsForServer[key] === "") {
        delete this.paramsForServer[key];
      }
    }
    if (this.paramsForServer.dateRange && (this.paramsForServer.dateRange.startDate === "" || this.paramsForServer.dateRange.endDate === "")) {
      delete this.paramsForServer.dateRange;
    }
    this.getAllUsers(this.paramsForServer);
  }

  selectedParams() {
    if (this.paramsForServer) {
      if (this.paramsForServer.departments) {
        for (let i = 0; i < this.paramsForServer.departments.length; i++) {
          const index = this.departments.findIndex(x => x.id === this.paramsForServer.departments[i]);
          if (index > -1) {
            this.paramsForDisplay.push(this.departments[index].name);
          }
        }
      }
      if (this.paramsForServer.positions) {
        for (let i = 0; i < this.paramsForServer.positions.length; i++) {
          const index = this.positions.findIndex(x => x.id === this.paramsForServer.positions[i]);
          if (index > -1) {
            this.paramsForDisplay.push(this.positions[index].name);
          }
        }
      }
      if (this.paramsForServer.language) {
        this.paramsForDisplay.push(...this.paramsForServer.language);
      }
      if (this.paramsForServer.status) {
        this.paramsForDisplay.push(...this.paramsForServer.status);
      }
      if (this.paramsForServer.roles) {
        this.paramsForDisplay.push(...this.paramsForServer.roles);
      }
      if (this.paramsForServer.dateRange) {
        this.paramsForDisplay.push(this.paramsForServer.dateRange.startDate + ' : ' + this.paramsForServer.dateRange.endDate);
      }
    }
  }

  deleteFromSelected(name) {
    this.paramsForDisplay.splice(this.paramsForDisplay.indexOf(name), 1);
    if (this.paramsForServer.departments) {
      const index = this.departments.findIndex(x => x.name === name);
      if (index > -1) {
        this.paramsForServer.departments.splice(this.departments[index].id, 1);
      }
    }
    if (this.paramsForServer.positions) {
      const index = this.positions.findIndex(x => x.name === name);
      if (index > -1) {
        this.paramsForServer.positions.splice(this.positions[index].id, 1);
      }
    }
    if (this.paramsForServer.language) {
      const index = this.paramsForServer.language.indexOf(name);
      if (index > -1) {
        this.paramsForServer.language.splice(index, 1);
      }
    }
    if (this.paramsForServer.status) {
      const index = this.paramsForServer.status.indexOf(name);
      if (index > -1) {
        this.paramsForServer.status.splice(index, 1);
      }
    }
    if (this.paramsForServer.roles) {
      const index = this.paramsForServer.roles.indexOf(name);
      if (index > -1) {
        this.paramsForServer.roles.splice(index, 1);
      }
    }
    if (this.paramsForServer.dateRange) {
      if ((this.paramsForServer.dateRange.startDate + ' : ' + this.paramsForServer.dateRange.endDate) === name) {
        delete this.paramsForServer.dateRange;
      }
    }
    this.sendParams(this.paramsForServer);
  }

  showParams() {
    const modalRef = this.modalService.open(SearchParams);
    modalRef.componentInstance.departments = this.departments;
    modalRef.componentInstance.positions = this.positions;
    if (!(this.isEmptyObject(this.paramsForServer))) {
      modalRef.componentInstance.searchState = this.searchParams;
    }
    modalRef.result.then((result) => {
      if (result) {
        this.paramsForDisplay.splice(0, this.paramsForDisplay.length);
        this.searchParams = result;
        this.sendParams(this.searchParams);
        this.selectedParams();
      }
    });
  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/users/users-standarts-report/users-standarts-report.component.ts